import styled from 'styled-components'
import measures from 'globals/measures'

export const ExportsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  
  & .ant-tabs {
    flex: 1;
    overflow: visible;
  }
`

export const ExportsDataTableWrapper = styled.div`
  background: white;
  padding: 20px 47px;
  margin: 40px 0;
  
  @media (max-width: ${measures.mobileThreshold}px) {
    padding: 11px;
  }
  
  & .hide-mobile {
    @media (max-width: ${measures.mobileThreshold}px) {
      display: none;
    }
  }
  
  & table {
    & > .ant-table-thead .ant-table-cell {
      line-height: 38px;
      padding: 0 22px;

      @media (max-width: ${measures.mobileThreshold}px) {
        padding: 0 11px 0 0;
      }
      
      & > span {
        @media (max-width: ${measures.mobileThreshold}px) {
          display: none;
        }
        
        &.title-mobile {
          display: none;
          
          @media (max-width: ${measures.mobileThreshold}px) {
            display: inline;
          }
        }
      }
    }
    
    & > .ant-table-tbody .ant-table-row td.ant-table-cell {
      line-height: 50px;
      border-bottom: none;
      padding: 0 22px;

      @media (max-width: ${measures.mobileThreshold}px) {
        padding: 0 11px 0 0;
      }
      
      & > a {
        font-weight: 600;
        text-decoration: underline;
      }
    }
    
    & > .ant-table-tbody .ant-table-row:nth-child(2n) {
      background: #F9F9F9;
    }
  }
`
